import React from 'react';
import { Alert } from '@mui/material';

import { usePatientIntakeStatusContext } from '../../hooks';

export const EmptyStepCard = () => {
  const { isHealthcareProvider } = usePatientIntakeStatusContext();

  if (isHealthcareProvider) {
    return (
      <Alert severity="info" sx={{ display: 'none', '&:only-child': { display: 'flex' } }}>
        There are no custom steps for this category. If this is an active form intake, you can create steps for the
        patient to complete.
      </Alert>
    );
  }

  // If the user is not a healthcare provider, they will see this alert when there are no more steps to complete
  return (
    <Alert severity="info" sx={{ '&:has(~ [data-incompleted=true])': { display: 'none' } }}>
      You do not have any steps to complete for the time being.
    </Alert>
  );
};
